// Tiny framework-agnostic pub/sub state. UI shells subscribe to keys they care
// about; tools mutate via setters. No reactivity framework — each consumer
// (Vue composable, Web Component) bridges this to its own reactivity layer.

const listeners = new Map(); // key -> Set<fn>

const state = {
  activeTool: 'bug-pin',
  selectedNode: null,
  selectedColor: '#D5000D',
  strokeWidth: 4,
  toolDefaults: {
    rectangle: { fill: false, radius: 6 },
    ellipse: { fill: false },
    line: { dashed: false },
    arrow: { head: 'standard' },
    text: { preset: 'box', fontSize: 20 },
    blur: { mode: 'pixelate', intensity: 10 },
  },
};

function notify(key) {
  const set = listeners.get(key);
  if (!set) return;
  for (const fn of set) fn(state[key]);
}

export function get(key) {
  return state[key];
}

export function set(key, value) {
  if (state[key] === value) return;
  state[key] = value;
  notify(key);
}

export function setToolDefault(toolId, patch) {
  state.toolDefaults[toolId] = { ...state.toolDefaults[toolId], ...patch };
  notify('toolDefaults');
}

export function subscribe(key, fn) {
  if (!listeners.has(key)) listeners.set(key, new Set());
  listeners.get(key).add(fn);
  return () => listeners.get(key).delete(fn);
}

export function reset() {
  state.activeTool = 'bug-pin';
  state.selectedNode = null;
  state.selectedColor = '#D5000D';
  state.strokeWidth = 4;
  notify('activeTool');
  notify('selectedNode');
  notify('selectedColor');
  notify('strokeWidth');
}
